export const stairEquipmentOptions = [
  { label: 'No Equipment Required', value: '' },
  { label: 'Ramp', value: 'ramp' },
  { label: 'Stair Chair', value: 'stair-chair' },
];
